import {sva} from "@styled-system/css";

export const alertPopupRecipe = sva({
    slots: ["root", "container", "icon", "message", "closeButton"],
    base: {
        root: {
            position: "fixed",
            top: "24px",
            right: "24px",
            zIndex: 1000,
            bg: "white",
            borderRadius: "md",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
            border: "1px solid #FF5349",
            padding: "12px 16px",
            minWidth: "375px",
            minHeight: "60px",
            alignItems: "center",
            justifyContent: "space-between",
            animation: "fadeIn 0.3s ease-in-out"
        },
        container: {
            display: "flex",
            gap: "3",
            alignItems: "center"
        },
        icon: {
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            bg: "#FF5349",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "xs",
            fontWeight: "bold",
            display: "flex"
        },
        message: {
            color: "#333",
            fontWeight: "medium"
        },
        closeButton: {
            cursor: "pointer",
            marginLeft: "12px",
            color: "#666",
            "&:hover": {
                color: "#333"
            }
        }
    },
    variants: {
        type: {
            error: {
                root: {
                    border: "1px solid #FF5349"
                },
                icon: {
                    bg: "#FF5349"
                }
            },
            warning: {
                root: {
                    border: "1px solid #FFD700"
                },
                icon: {
                    bg: "#FFD700",
                    color: "#333"
                }
            },
            success: {
                root: {
                    border: "1px solid #4CAF50"
                },
                icon: {
                    bg: "#4CAF50"
                }
            },
            info: {
                root: {
                    border: "1px solid #2196F3"
                },
                icon: {
                    bg: "#2196F3"
                }
            }
        }
    },
    defaultVariants: {
        type: "error"
    }
});
